// General
import { createSlice } from "@reduxjs/toolkit";
// Services
import { sessionService } from "../../services/session.service";
// Static Data
import { API_CONFIG_HEADERS } from "../../const/apiConst";

const initialState = {
  // General variables
  isLoggedIn: false,
  apiToken: "",
  spiToken: "",

  // Timer variables
  dailyCheckInTimer: null,

  // Interval variables
  dailyCheckInInterval: null,

  // Redirect Handler variables
  redirectHandler: {
    url: null,
    fromCta: null,
    token: null,
  },

  // VPN variables
  vpnBlockInfo: null,

  // Initial Routing Path variables
  initialRoutingPath: null, // Not Using Yet

  // Utility variables
  userAioRan: false,
};

export const publicSlice = createSlice({
  name: "public",
  initialState,
  reducers: {
    // General Functions
    updateIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;

      if (action.payload === false) {
        sessionService.deleteAllSessionData();
      }
    },
    updateApiToken: (state, action) => {
      state.apiToken = action.payload;

      API_CONFIG_HEADERS.SB_API_HEADERS.Authorization = `${action.payload}`;
      API_CONFIG_HEADERS.SB_API_HEADERS.token = `${action.payload}`;
      API_CONFIG_HEADERS.SB_API_HEADERS_FORM_DATA.Authorization = `${action.payload}`;
      API_CONFIG_HEADERS.SB_API_HEADERS_FORM_DATA.token = `${action.payload}`;
      API_CONFIG_HEADERS.COM_HEADERS.token = action.payload;
      API_CONFIG_HEADERS.COM_HEADERS_FORM_DATA.token = action.payload;

      sessionService.setApiToken(action.payload);
    },

    updateSpiToken: (state, action) => {
      state.spiToken = action.payload;

      API_CONFIG_HEADERS.SPI_HEADERS.Authorization = `Bearer ${action.payload}`;

      sessionService.setSpiToken(action.payload);
    },

    updateRefreshToken: (state, action) => {
      API_CONFIG_HEADERS.REFRESH_TOKEN_HEADERS.token = `${action.payload}`;
      API_CONFIG_HEADERS.REFRESH_TOKEN_HEADERS.Authorization = `Bearer ${action.payload}`;
    },

    // Timer Functions
    setDailyCheckInTimer: (state, action) => {
      state.dailyCheckInTimer = action.payload;
    },
    updateDailyCheckInTimer: (state) => {
      if (state.dailyCheckInTimer <= 0) return;

      state.dailyCheckInTimer--;
    },
    resetDailyCheckInTimer: (state) => {
      state.dailyCheckInTimer = null;
    },

    // Interval Functions
    updateDailyCheckInInterval: (state, action) => {
      if (state.dailyCheckInInterval) return;

      state.dailyCheckInInterval = action.payload;
    },
    clearDailyCheckInInterval: (state) => {
      clearInterval(state.dailyCheckInInterval);
      state.dailyCheckInInterval = null;
    },

    // Redirect Handler Functions
    updateRedirectHandler: (state, action) => {
      state.redirectHandler.url = action.payload.url;
      state.redirectHandler.fromCta = action.payload.fromCta;
      state.redirectHandler.token = action.payload.token;
    },

    // VPN Functions
    updateVpnBlockInfo: (state, action) => {
      state.vpnBlockInfo = action.payload;
    },

    // Initial Routing Path Functions
    updateInitialRoutingPath: (state, action) => {
      state.initialRoutingPath = action.payload;
    },

    // Utility Functions
    resetPublicStore: () => {
      return { ...initialState };
    },
    updateUserAioRan: (state, action) => {
      state.userAioRan = action.payload;
    },
  },
});

export const {
  // General Functions
  updateIsLoggedIn,
  updateApiToken,
  updateSpiToken,
  updateRefreshToken,

  // Timer Functions
  setDailyCheckInTimer,
  updateDailyCheckInTimer,
  resetDailyCheckInTimer,

  // Interval Functions
  updateDailyCheckInInterval,
  clearDailyCheckInInterval,

  // Redirect Handler Functions
  updateRedirectHandler,

  // VPN Functions
  updateVpnBlockInfo,

  // Initial Routing Path Functions
  updateInitialRoutingPath,

  // Utility Functions
  resetPublicStore,
  updateUserAioRan,
} = publicSlice.actions;

export default publicSlice.reducer;
